import type { NextPage } from 'next';
import { Page as Component } from '~/components/specifics/vendors/deals/[id]/messages/Page';
import { NskHead } from '~/components/common/head/NskHead';

export const PATH = (id: number): string => `/vendors/deals/${id}/messages`;

const DealsDetail: NextPage = () => (
  <>
    <NskHead title="管理会社とチャット" />
    <Component />
  </>
);

export default DealsDetail;
